import React from 'react'
import CurvedBottomArrowSvg from './Svg/CurvedBottomArrowSvg'
import { SxProps, useMediaQuery } from '@mui/system'
import { useTheme } from '@mui/material'
import { GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS, GUI_LIVE_VIEW_BREAKPOINT_XXS } from 'src/Libs/live-view/utils/breakpoints'
import CurvedBottomArrowXxsSvg from './Svg/CurvedBottomArrowXxsSvg'
import CurvedBottomArrowXsSvg from './Svg/CurvedBottomArrowXsSvg'
import CurvedBottomArrow360Svg from './Svg/CurvedBottomArrow360Svg'

interface Props {
  doNotFlow?: boolean
  directionIsReversed?: boolean
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const CurvedSecondLevelArrow: React.FC<Props> = ({ doNotFlow, directionIsReversed, doRotateBy180Deg = false, sx }) => {
  const direction = doNotFlow ? undefined : directionIsReversed ? 'out' : 'in'
  const transform = 'translateX(0)'
  const combinedSx = { width: 'fit-content', ...sx }
  const theme = useTheme()
  const isUpXxs = useMediaQuery(theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XXS))
  const isUpXs = useMediaQuery(theme.breakpoints.up(GUI_LIVE_VIEW_BREAKPOINT_XS))
  const isBetween360AndXs = useMediaQuery(theme.breakpoints.between(GUI_LIVE_VIEW_BREAKPOINT_360, GUI_LIVE_VIEW_BREAKPOINT_XS))

  if (isUpXs) {
    return <CurvedBottomArrowSvg transform={transform} sx={combinedSx} direction={direction} doRotateBy180Deg={doRotateBy180Deg} />
  }

  if (isBetween360AndXs) {
    return <CurvedBottomArrow360Svg transform={transform} sx={combinedSx} direction={direction} doRotateBy180Deg={doRotateBy180Deg} />
  }

  if (isUpXxs) {
    return <CurvedBottomArrowXsSvg transform={transform} sx={combinedSx} direction={direction} doRotateBy180Deg={doRotateBy180Deg} />
  }

  return <CurvedBottomArrowXxsSvg transform={transform} sx={combinedSx} direction={direction} doRotateBy180Deg={doRotateBy180Deg} />
}

export default CurvedSecondLevelArrow
